import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.25711 0.28625L0.224609 1.32458L5.99961 7.09375L11.7746 1.31875L10.7421 0.28625L5.99961 5.02875L1.25711 0.28625Z",
		fill: "#7B7BFF"
	})
});
export { SvgArrowDown as ReactComponent };
